
import errors from './errors/reducer';
import connectionState from './connectionState/reducer';
import success from './success/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('key', {
  errors,
  connectionState,
  success
});



/** WEBPACK FOOTER **
 ** ./src/members/state/info/reducer.js
 **/